import axios from "axios";
import { alertMessages, 
  getNfdrWithoutTimeQuery, 
  nfdrMinMaxWithTimeQuery, 
  nfdrHourlyQuery, 
  percentileLevelsQuery, 
  getQueueDownloadJobsStatusQuery,
  getStatusRecalcQuery,
} from "src/constants";
import { errorResponse, checkAdminRole } from "src/store/common";
import { configurationClimatology } from "./getWeatherCalls";
import { configMutationClimatology } from "./mutationsApiKey";

export const getPercentileLevels = async (request: any, addAlert: any, user?: any) => {
  try {
    let dataPercLevels = JSON.stringify({
      query: percentileLevelsQuery,
      variables: request
    });
    let config = (checkAdminRole(user) && user)? configMutationClimatology(dataPercLevels): configurationClimatology(dataPercLevels)
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {
            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const nfdrsObs = response.data.data.percentileLevels.data;
              return resolve(nfdrsObs);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            if (error.response?.data.errors[0].message.includes('famauth')) {
              return reject(new Error(error))
            } else {
              errorResponse(error, addAlert, alertMessages.retrievingStationData);
              return reject(new Error(error))
            }
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};

export const getCharts = async (query: string, request: any, addAlert: any, user?:any) => {
  try {
    let dataNfdrsObs = JSON.stringify({
      query: query,
      variables: request
    });
    let config = checkAdminRole(user) && user? configMutationClimatology(dataNfdrsObs): configurationClimatology(dataNfdrsObs);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {

            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const nfdrsObs = response.data.data.percentileAvgMinMax.data;
              return resolve(nfdrsObs);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            if (error.response?.data.errors[0].message.includes('famauth')) {
              return reject(new Error(error))
            } else {
              errorResponse(error, addAlert, alertMessages.retrievingStationData);
              return reject(new Error(error))
            }
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};

export const getNfdrHourly = async(request:any, addAlert: any, user?:any)=>{
    try{
        let dataNfdrsObs = JSON.stringify({
            query: nfdrHourlyQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDateRange: request.startDate,
                endDateRange: request.endDate,
                startHour: Number(request.startHour),
                endHour: Number(request.endHour),
                dateTimeFormat: request.dateTimeFormat,
                stationIds: request.stationIds,
                sortBy: request.sortBy,
                sortOrder: request.sortOrder,
                page: request.page,
                per_page: request.perPage,
                fuelModel: request.fuelModel,
                nfdrType: 'appended',
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL'
            }
        });
        let config =  checkAdminRole(user) && user ? configMutationClimatology(dataNfdrsObs) : configurationClimatology(dataNfdrsObs);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const nfdrsObs = response.data.data.nfdrsObs;
                    return resolve(nfdrsObs);
                  }
                
                })
                .catch(function (error: any) {
                  console.log('error', error);
                  if (error.response?.data.errors[0].message.includes('famauth')) {
                    return reject(new Error(error))
                  } else {
                    errorResponse(error, addAlert, alertMessages.retrievingStationData);
                    return reject(new Error(error))
                  }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

export const getNfdrMinMax = async(request:any, addAlert: any, user?: any)=>{
    try{
        let dataNfdrMinMax = JSON.stringify({
            query: getNfdrWithoutTimeQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                stationIds: request.stationIds,
                page: request.page,
                per_page: request.perPage,
                fuelModel: request.fuelModel,
                hasHistoricData: 'ALL',
                visibilitySettings: 'ALL',
            }
        });
        let config = checkAdminRole(user) && user ? configMutationClimatology(dataNfdrMinMax): configurationClimatology(dataNfdrMinMax);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const nfdrMinMax = response.data.data.nfdrMinMax.data;
                    return resolve(nfdrMinMax);
                  }
                
                })
                .catch(function (error: any) {
                    console.log('error', error);
                    if (error.response?.data.errors[0].message.includes('famauth')) {
                      return reject(new Error(error))
                    } else {
                      errorResponse(error, addAlert, alertMessages.retrievingStationData);
                      return reject(new Error(error))
                    }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

export const getNfdrMinMaxInclTime = async(request:any, addAlert: any, user?: any)=>{
    try{
        let dataNfdrMinMaxInclTime = JSON.stringify({
            query: nfdrMinMaxWithTimeQuery,
            variables: {
                zoomLevel: request.zoomLevel,
                startDate: request.startDate,
                endDate: request.endDate,
                stationIds: request.stationIds,
                sortBy: request.sortBy,
                sortOrder: request.sortOrder,
                page: request.page,
                per_page: request.perPage,
                fuelModel: request.fuelModel,		
                hasHistoricData: 'ALL',	
                visibilitySettings: 'ALL'
            }
        });
        let config = checkAdminRole(user) && user? configMutationClimatology(dataNfdrMinMaxInclTime): configurationClimatology(dataNfdrMinMaxInclTime);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const nfdrMinMax = response.data.data.nfdrMinMax;
                    return resolve(nfdrMinMax);
                  }
                
                })
                .catch(function (error: any) {
                    console.log('error', error);
                    if (error.response?.data.errors[0].message.includes('famauth')) {
                      return reject(new Error(error))
                    } else {
                      errorResponse(error, addAlert, alertMessages.retrievingStationData);
                      return reject(new Error(error))
                    }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};

export const getStatusRecalc = async(request:any, addAlert: any)=>{
    try{
        let dataRecalcStatus = JSON.stringify({
            query: getStatusRecalcQuery,
            variables: {
                stationName: request.stationName,
                fuelModelCatalogName: request.fuelModelCatalogName,
                droughtCatalogName: request.droughtCatalogName,
                liveCatalogName: request.liveCatalogName,
                deadCatalogName: request.deadCatalogName,
                sortOrder: request.sortOrder,
                sortBy: request.sortBy,
                perPage: request.perPage,
                page: request.page,		
            }
        });
        let config = configurationClimatology(dataRecalcStatus);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  if(response.data.errors && response.data.errors.length > 0){
                    return reject(new Error(response.data.errors));
                  }else{
                    const getRecalcStatusResponse = response.data.data.getRecalcStatus;
                    return resolve(getRecalcStatusResponse);
                  }
                
                })
                .catch(function (error: any) {
                    console.log('error', error);
                    errorResponse(error, addAlert, alertMessages.retrievingStationData);
                    return reject(new Error(error))
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
  };
  

export const getQueueDownloadJobsStatus = async(request:any, addAlert: any)=>{
    try{
        let queueDLQuery = JSON.stringify({
            query: getQueueDownloadJobsStatusQuery,
            variables: {
              hideStaleJobs: request.hideStaleJobs,
              jobIds: request.jobIds,
              sortBy: request.sortBy, 
              sortOrder: request.sortOrder,
              page: request.page,
              per_page: request.perPage
            }
        });
        let config = configMutationClimatology(queueDLQuery, null);
        return(
            new Promise(function(resolve,reject){
                axios(config)
                .then(function(response: any){
                  if(response.data.data.exportJobStatus){
                    return resolve(response.data.data)
                  }
                  else{
                    console.log('response error', response)
                    return reject(new Error(response.data.errors[0]?.message))
                  }
                
                })
                .catch(function (error: any) {
                  console.log('error', error);
                  if (error.response?.data.errors[0].message.includes('famauth')) {
                    return reject(new Error(error))
                  } else {
                    errorResponse(error, addAlert, alertMessages.exportDownloadData);
                    return reject(new Error(error))
                  }
                });
            })
          );

    }
    catch(error){
        console.log('error', error);

    }
};
